<template>
    <div class="loader">
        <b-alert show variant="danger" v-if="isVisible">
            <h4 class="alert-heading">
                {{ title }}

                <div class="ml-4 pull-right">
                    <b-spinner variant="danger" label="Spinning"/>
                </div>
            </h4>
            <p class="mb-0">{{ message }}</p>
        </b-alert>
    </div>
</template>

<script>
import EventBus from "@mobile/utils/event-bus";

export default {
    name: "Loader",
    data() {
        return {
            isVisible: false,
            title: 'Loading',
            message: 'Please wait...',
            event: null
        }
    },
    mounted() {
        EventBus.$on('SHOW_LOADER', (event) => {
            this.isVisible = true;
            this.title = event.title ? event.title : 'Loading';
            this.message = event.message ? event.message : 'Please wait...';
            this.event = event.event ? event.event : null;
        });

        EventBus.$on('HIDE_LOADER', () => {
            this.isVisible = false;
            this.event = null;
        });
    },
    beforeDestroy() {
        EventBus.$off('SHOW_LOADER');
        EventBus.$off('HIDE_LOADER');
    }
}
</script>

<style scoped>
    .loader{
        position: fixed;
        z-index: 9999;
        right: 0;
        bottom: 0;
        width: 400px;
        height: auto;
    }
</style>
